import { useInfiniteQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getSettlements } from 'services/fund/settlement'

export default function useGetSettlements() {
    const { moneyPool } = useParams()
    const { data, isLoading, fetchNextPage, refetch } = useInfiniteQuery(
        ['my-settlements', moneyPool],
        ({ pageParam = 1, queryKey }) => getSettlements(pageParam, moneyPool),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return {
        settlements: data,
        isLoadingSettlements: isLoading,
        fetchNextPage,
        refetch,
    }
}
